import { request } from "@umijs/max";

/** 获取 Bootstrap 数据 GET /app/bootstrap/user-web-jp */
export async function getBootstrapData() {
  return request<API.BootstrapData>("/app/bootstrap/user-web-jp", {
    method: "GET",
  });
}
